import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAcneFiveGlyph from './svgs/AcneFiveGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var acneFiveGlyph = (props => useIcon(SvgAcneFiveGlyph, SvgAcneFiveGlyph, props));

export { acneFiveGlyph as default };
